import { Component, OnInit } from '@angular/core';
import { AdminServicesService } from '../admin-services.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-change-pwd-admin',
  templateUrl: './change-pwd-admin.component.html',
  styleUrls: ['./change-pwd-admin.component.css']
})
export class ChangePwdAdminComponent implements OnInit {

  public userName: any;
  public old_pswd: any;
  public new_pswd: any;
  public cnfPasw: any;
  userDtls: any;
  constructor(public admin: AdminServicesService,
    public router: Router,
    public toastr: ToastrService) {

      if (!localStorage.getItem('userDetails')) {
        alert("User Already Loged out , Please Login Again");
        this.router.navigate(["login-admin"]);
      } else {
        this.userDtls = JSON.parse(localStorage.getItem('userDetails'));
      }
    // let a = JSON.parse(localStorage.getItem('userDetails'));
    this.userName = this.userDtls.userName
  }

  ngOnInit(): void {
  }

  submit() {
    if (!this.old_pswd) {
      return this.toastr.error("Old Password Empty");
    } else if (!this.new_pswd) {
      return this.toastr.error("New Password Empty");
    } else if (!this.cnfPasw) {
      return this.toastr.error("Conform Password Empty");
    } else if (this.new_pswd != this.cnfPasw) {
      return this.toastr.error("Password Mismatch");
    } else {
      let obj = {
        "userName": this.userName,
        "old_pswd": this.old_pswd,
        "new_pswd": this.new_pswd,
        "cnfPasw": this.cnfPasw
      }
      this.admin.changepwd(obj).subscribe((res: any) => {
        if (res.code === 200) {
          this.toastr.success(res.message);
          setTimeout(() => {
            this.router.navigate(['login-admin']);
          }, 300);
        } else {
          this.toastr.error(res.message);
        }
      }, (err) => {
        this.toastr.error(err);
      })
    }
  }

  reset() {
    this.old_pswd = null;
    this.cnfPasw = null;
    this.new_pswd = null;
  }

}
